<script setup>
import { useAuthStore } from '@/store/auth';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import AppMenuItem from './AppMenuItem.vue';

const { t } = useI18n();
const authStore = useAuthStore();


const model = computed(() => [
    {
        label: t('menu.reservations'),
        items: [
            { label: t('menu.calendar'), icon: 'fa-regular fa-calendar', to: '/' },
            { label: t('menu.newReservation'), icon: 'fa-regular fa-calendar-plus', to: '/new', meta: { roles: ['ManageInternalReservations', 'ManageOwnReservations'] } },
        ]
    },
    {
        label: t('menu.resources'),
        items: [
            { label: t('menu.maintenances'), icon: 'fa fa-wrench', to: '/maintenances', meta: { roles: ['ManageResourcesMaintainance'] } },
            { label: t('menu.resources'), icon: 'fa fa-list', to: '/resources', meta: { roles: ['ManageResources', 'ManageResourcesTimeSlots'] } },
            { label: t('menu.customFields'), icon: 'fa fa-layer-group', to: '/custom-fields', meta: { roles: ['ManageResources'] } }
        ]
    },
    {
        label: t('menu.users'),
        items: [
            { label: t('menu.users'), icon: 'fa fa-users', to: '/users', meta: { roles: ['ManageUsers'] } },
            { label: t('menu.groups'), icon: 'fa fa-people-group', to: '/groups', meta: { roles: ['ManageGroups', 'ManageResourcesReferents'] } },
        ]
    }
]);

const filteredModel = computed(() => {
    return model.value
        .map(section => ({
            ...section,
            items: section.items?.filter(child =>
                !child.meta?.roles || authStore.hasAnyAuthorization(child.meta.roles)
            )
        }))
        .filter(section => !section.items || section.items.length > 0);
});
</script>

<template>
    <ul class="layout-menu">
        <template v-for="(item, i) in filteredModel" :key="item">
            <app-menu-item v-if="!item.separator" :item="item" :index="i"></app-menu-item>
            <li v-if="item.separator" class="menu-separator"></li>
        </template>
    </ul>
</template>

<style lang="scss" scoped></style>